import { DateTime } from 'luxon'

export class Language {
	id: number
	name: string
	ietf: string
	active: boolean
	default: boolean
	createdAt: DateTime
	updatedAt: DateTime

	constructor(
		id: number,
		name: string,
		ietf: string,
		active: boolean,
		defaultValue: boolean,
		createdAt: DateTime,
		updatedAt: DateTime
	) {
		this.id = id
		this.name = name
		this.ietf = ietf
		this.active = active
		this.default = defaultValue
		this.createdAt = createdAt
		this.updatedAt = updatedAt
	}
}
